import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { ApiUrl } from '../../../services/ApiRest';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const Reports = () => {
    const fechaActual = new Date().toISOString().split('T')[0];
    const [data, setdata] = useState([]);
    const [sumTotalBeginningDay, setsumTotalBeginningDay] = useState(0);
    const [sumTotalInventory, setsumTotalInventory] = useState(0);
    const [sumTotalFree, setsumTotalFree] = useState(0);
    const [sumTotalMermas, setSumTotalMermas] = useState(0);
    const [sumTotalEgress, setSumTotalEgress] = useState(0);
    const [cashFlow, setcashFlow] = useState(0);
    const [sumTotalExtraIncome, setSumTotalExtraIncome] = useState(0);

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    // Función para cargar datos iniciales (opcional)
    const loadInitialData = async () => {
        try {
            const formData = new FormData();
            formData.append("startDate", fechaActual);
            formData.append("endDate", fechaActual);
            
            const response = await axios.post(ApiUrl + 'report-list-by-date', formData);
            const respData = response.data;
            console.log('RESP CUANDO ESTODO:',respData);
            if (respData.totals) {
                updateTotals(respData.totals);
            }
        } catch (error) {
            console.log('Error loading initial data:', error);
        }
    };

    // Función para actualizar los totales
    const updateTotals = (totals) => {
        setsumTotalFree(totals.sumTotalFree || 0);
        setsumTotalInventory(totals.sumTotalInventory || 0);
        setsumTotalBeginningDay(totals.sumTotalBeginningDay || 0);
        setSumTotalExtraIncome(totals.sumTotalExtraIncome || 0);
        setSumTotalEgress(totals.sumTotalEgress || 0);
        setSumTotalMermas(totals.sumTotalMermas || 0);
        setcashFlow(totals.cashFlow || 0);
    };

    // Función para buscar por rango de fechas
    const handleSearch = async (event) => {
        event.preventDefault();
        
        if (!startDate || !endDate) {
            toast.error("Por favor seleccione ambas fechas", { position: toast.POSITION.BOTTOM_RIGHT });
            return;
        }
        
        const formData = new FormData();
        formData.append("startDate", startDate);
        formData.append("endDate", endDate);
        
        try {
            const responseSearch = await axios.post(ApiUrl + 'report-list-by-date', formData);
            const respSearch = responseSearch.data;
            
            console.log('Datos recibidos:', respSearch);
            
            // Actualizar los datos de las listas
            setdata(respSearch);
            console.log('Datos actualizados:', respSearch);
            
            // Actualizar los totales
            if (respSearch.totals) {
                updateTotals(respSearch.totals);
                toast.success("Datos cargados correctamente", { position: toast.POSITION.BOTTOM_RIGHT });
            }
            
        } catch (error) {
            console.log('Error en la búsqueda:', error);
            toast.error("Error al cargar los datos: " + error.message, { position: toast.POSITION.BOTTOM_RIGHT });
        }
    };

    // Función para mostrar todos los datos
    const handleShowAll = async () => {
        // Limpiar los inputs
        setStartDate('');
        setEndDate('');
        
        // Cargar datos del día actual
        await loadInitialData();
        
        toast.info("Mostrando datos del día actual", { position: toast.POSITION.BOTTOM_RIGHT });
    };

    // Función para formatear números como moneda
    const formatCurrency = (value) => {
        return new Intl.NumberFormat('es-EC', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
        }).format(value || 0);
    };

    // Cargar datos iniciales al montar el componente
    useEffect(() => {
        loadInitialData();
    }, []);

    return (
        <div>
            <div className='row'>
                <div className='col-12 '>
                    <div className="card">
                        <div className="card-header">
                            FIN DE DÍA
                        </div>
                        <div className="card-body">
                            <div className='row mb-3'>
                                <div className='col-md-4 d-flex align-items-end'>
                                    <div className="form-group me-2 w-100">
                                        <label className="me-2">Fecha Inicio</label>
                                        <input
                                            type="date"
                                            name='startDate'
                                            className="form-control input-full-width"
                                            value={startDate}
                                            onChange={(e) => setStartDate(e.target.value)}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className='col-md-4 d-flex align-items-end'>
                                    <div className="form-group me-2 w-100">
                                        <label className="me-2">Fecha Fin</label>
                                        <input
                                            type="date"
                                            className="form-control input-full-width"
                                            name='endDate'
                                            value={endDate}
                                            onChange={(e) => setEndDate(e.target.value)}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className='col-md-4 d-flex align-items-end'>
                                    <div className="d-flex w-100">
                                        <button 
                                            type="button" 
                                            className="btn btn-success me-2" 
                                            onClick={handleSearch} 
                                            style={{ marginBottom: '16px' }}
                                        >
                                            Buscar
                                        </button>
                                        <button 
                                            type="button" 
                                            className="btn btn-success" 
                                            onClick={handleShowAll} 
                                            style={{ marginBottom: '16px' }}
                                        >
                                            Mostrar datos del día
                                        </button>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="row">
                                {/* Tabla de Ingresos */}
                                <div className="col-md-6">
                                    <table className="table table-bordered text-center">
                                        <thead className="table-success">
                                            <tr>
                                                <th>INGRESOS</th>
                                                <th>VALORES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Ingresos de ventas sin inventario</td>
                                                <td>{formatCurrency(sumTotalFree)}</td>
                                            </tr>
                                            <tr>
                                                <td>Ingresos de ventas de inventario</td>
                                                <td>{formatCurrency(sumTotalInventory)}</td>
                                            </tr>
                                            <tr>
                                                <td>Inicio de día</td>
                                                <td>{formatCurrency(sumTotalBeginningDay)}</td>
                                            </tr>
                                            <tr>
                                                <td>Ingresos extras</td>
                                                <td>{formatCurrency(sumTotalExtraIncome)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                {/* Tabla de Egresos */}
                                <div className="col-md-6">
                                    <table className="table table-bordered text-center">
                                        <thead className="table-danger">
                                            <tr>
                                                <th>EGRESOS</th>
                                                <th>VALORES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Total egreso diario</td>
                                                <td>{formatCurrency(sumTotalEgress)}</td>
                                            </tr>
                                            <tr>
                                                <td>Total egreso merma</td>
                                                <td>{formatCurrency(sumTotalMermas)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            
                            <br />
                            <br />
                            <br />
                            
                            {/* Tabla de Valor TOTAL */}
                            <center>
                                <div className="col-md-6">
                                    <table className="table table-bordered text-center">
                                        <thead className={`table-${cashFlow >= 0 ? 'success' : 'danger'}`}>
                                            <tr>
                                                <th>UTILIDAD</th>
                                                <th>{formatCurrency(cashFlow)}</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </center>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer theme="colored" />
        </div>
    );
};

export default Reports;